<div class="delete-modal-inner">
    @if(action === 'delete') {
    <h2 mat-dialog-title>{{msg.DELETE_PROJECT_TITLE}}</h2>
    }
    @if(action === 'save_changes') {
    <h2 mat-dialog-title>{{msg.SAVE_CHANGES_TITLE}}</h2>
    }
    @if(action === 'delete-translation') {
    <h2 mat-dialog-title>{{msg.DELETE_TRANSLATION_PROJECT_TITLE}}</h2>
    }
    <mat-dialog-content>
        @if(action === 'delete') {
        <p>{{msg.DELETE_PROJECT}}</p>
        }
        @if(action === 'delete-translation') {
        <p>{{msg.DELETE_TRANSLATION_PROJECT}}</p>
        }
        @if(action === 'save_changes') {
        <p>{{msg.SAVE_CHANGES_MSG}}</p>
        }
        <span>Note: This action cannot be undone.</span>
    </mat-dialog-content>
    @if (action === 'delete' || action === 'delete-translation') {
    <mat-dialog-actions class="delete-buttons">
        <button mat-button [mat-dialog-close]="false">{{msg.CANCEL}}</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="delete-btn">{{msg.DELETE}}</button>
    </mat-dialog-actions>
    }
    @if (action === 'save_changes') {
    <mat-dialog-actions class="delete-buttons save-changes-buttons">
        <button style="padding-left: 0px;" mat-button [mat-dialog-close]="false">{{msg.CANCEL}}</button>
        <div>
            <button mat-button [mat-dialog-close]="save" class="save-btn">{{msg.SAVE_CHANGES}}</button>
            <button mat-button [mat-dialog-close]="proceed" cdkFocusInitial
                class="delete-btn">{{msg.DISCARD_CHANGES}}</button>
        </div>
    </mat-dialog-actions>
    }

</div>